var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScVdocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.907,
    height: 19.901,
    viewBox: "0 0 15.907 19.901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M5.14,21.279h9.334a2.813,2.813,0,0,0,2.087-.708,2.878,2.878,0,0,0,.7-2.105V10.5a6.441,6.441,0,0,0-.066-1,2.23,2.23,0,0,0-.252-.743,3.462,3.462,0,0,0-.556-.71L11.67,3.26a2.735,2.735,0,0,0-1.037-.709,4.1,4.1,0,0,0-1.3-.173H5.14a2.806,2.806,0,0,0-2.083.712,2.882,2.882,0,0,0-.7,2.109V18.466a2.867,2.867,0,0,0,.7,2.105A2.816,2.816,0,0,0,5.14,21.279ZM5.245,19.7a1.309,1.309,0,0,1-.981-.338,1.339,1.339,0,0,1-.328-.972V5.27A1.332,1.332,0,0,1,4.268,4.3a1.314,1.314,0,0,1,.986-.342H9.069V8.9a1.8,1.8,0,0,0,.439,1.326,1.789,1.789,0,0,0,1.317.439h4.861V18.4A1.176,1.176,0,0,1,14.361,19.7ZM10.994,9.234a.434.434,0,0,1-.5-.5V4.212l4.945,5.022Z",
    transform: "translate(-1.854 -1.878)",
    fill: "#333",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScVdocument);
export default __webpack_public_path__ + "static/media/SCVdocument.937feb3aecf5f45192a5bbe083f9048b.svg";
export { ForwardRef as ReactComponent };